// Reuse this functions on components
// https://v2.vuejs.org/v2/guide/mixins.html?redirect=true
/***
 * new Vue({
 * mixins: [mixin],
 * data: function () {
 *     return {
 *      message: 'goodbye',
 *    }
 *  },
 *  created: function () {
 *    console.log(this.fn(this.message))
 *  }
 * })
 */
const { uniqueNamesGenerator, adjectives, colors, animals } = require('unique-names-generator');


export default {
    data: function () {
      return {
        mapSizePerCredit: {
            small: 1, 
            medium: 2, 
            large: 5
        },
        mapSizeMinCredits: {
            small: 10000,
            medium: 20000,
            large: 50000,
        },
        language: 'Multilingual',
        modelTrials: 1,
        modelSize: 'small',
        modelBase: null,
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser;
        },
        currentOrg() {
            return this.$store.state.currentUser;
        },
        project(){
            return this.$store.state.project
        },
        rows(){
            return this.$store.state.rows
        },
    },
    methods: {
        getUserPlan(){
            // if payment.plan value exists, otherwise get the plan.name value
            let hasPaymentPlan = Object.hasOwn(this.currentUser, 'payment') ? Object.hasOwn(this.currentUser.payment, 'plan') : false
            let hasPlanName = Object.hasOwn(this.currentUser, 'plan') ? Object.hasOwn(this.currentUser.plan, 'name') : false
            
            if(hasPaymentPlan){
                return this.currentUser.payment.plan.toLowerCase()
            }
            let plan = hasPlanName ? this.currentUser.plan.name.toLowerCase() : "starter"
            return plan
        },
        isFreePlan(){
            return ['starter', 'free'].includes(this.getUserPlan())
        },
        isProPlan(){
            return this.getUserPlan() == "pro"
        },
        // Model train credits
        getProjectRowsLimit(){
            let hasDatasetRowsLimit = Object.hasOwn(this.currentUser, 'plan') ? Object.hasOwn(this.currentUser.plan, 'datasetRowsLimit') : false
            let recordsLimit = hasDatasetRowsLimit ? this.currentUser.plan.datasetRowsLimit : 1000
            return recordsLimit
        },
        getRowsAdded(size = 'small'){
            return Math.max(this.mapSizeMinCredits[size], this.rows.length)
        },
        creditsNeeded(dot = 1){
            let size = this.modelSize || this.project.size
            let rowsLength = this.getRowsAdded(size)
            let dot2 = dot ? dot == 1 : this.mapSizePerCredit[size]
            let aproxMinutes = rowsLength + 60 * parseInt(rowsLength / (dot2*1000)) // for 100 rows
            
            return parseInt(aproxMinutes)
        },
        hasEnoughCredits(){
            let credits = this.currentUser.creditsRemaining
            let records = this.creditsNeeded()
            return credits >= records
        },
        availableCredits(){
            let credits = this.currentUser.creditsRemaining
            return credits || 0
        },
        openLoading() {
            let isFullPage = true
            const loadingComponent = this.$buefy.loading.open({
                container: isFullPage ? null : this.$refs.element.$el
            })
            setTimeout(() => loadingComponent.close(), 3 * 1000)
        },
        create() {

            this.$buefy.notification.open('Starting model training...')
            
            this.createModel()

            this.openLoading()

            this.$emit('close')

        },
        createModel(){
            
            this.$buefy.toast.open(`Queueing...`)
            
            const model = {
                name: this.uniqueReadableName(),
                type: this.project.type,
                size: this.modelSize || this.project.size,
                language: this.language || this.project.language,
                modelBase: this.modelBase,
                projectId: this.project.id,
                datasetId: this.project.datasetId,
                strategy: 'fine-tune',
                trials: this.modelTrials || 0,
                creditsCost: this.creditsNeeded(),
                state: {
                    status: 'queued',
                    msg: 'Queued'
                }
            }

            var newDoc = this.$store.dispatch("createModel",
                model
            );

            const toUpdateCreditsConsumed = {
                userId: this.$firebase.auth().currentUser.uid,
                creditConsumed: this.creditsNeeded()
            }

            this.$store.dispatch("updateAPICreditsConsumed", 
                toUpdateCreditsConsumed
            );

            newDoc.then(newModelId => {
                
                if(this.project.models != undefined){
                  this.project.models.push(newModelId)
                } else {
                  this.project.models = [newModelId]
                }

                const addModelToProject = {
                  projectId: this.project.id,
                  add: {
                    models: this.project.models,
                    modelId: newModelId
                  }
                }
                this.$store.dispatch("addModelToProject",
                  addModelToProject
                );
                
            })

            this.$store.dispatch("showViewModels", true)

        },
        uniqueReadableName(){

            const shortName = uniqueNamesGenerator({
                dictionaries: [animals, colors], // colors can be omitted here as not used
                length: 2
            }); // big-donkey
            return shortName
  
        },
    }
}